import {
  EuiFormFieldset,
  EuiSwitch,
  EuiSplitPanel,
  EuiSpacer,
  EuiAvatar,
} from "@elastic/eui";


import { useTranslation } from 'react-i18next';

export function SuitabilityLegend() {
  const { t } = useTranslation();
  return (
    <div style={{fontSize: "14px"}}>
          <EuiSpacer size="xl" />

          <EuiAvatar size="s" name="4" color={"#ffa701"}/>
          <span>  {t('High Suitability')}</span>

          <EuiSpacer size="s" />

          <EuiAvatar size="s" name="3" color={"#ffda00"}/>
          <span>  {t('Good Suitability')}</span>

          <EuiSpacer size="s" />

          <EuiAvatar size="s" name="2" color={"#ffff33"}/>
          <span>  {t('Low Suitability')}</span>

          <EuiSpacer size="s" />

          <EuiAvatar size="s" name="1" color={"#2DC4B2"}/>
          <span>  {t('Not Suitable')}</span>

    </div>
  );
}